import PaginatedReportsTab from '../../components/paginated-reports-tab';

export default function ReportsTab() {
  return (
    <PaginatedReportsTab
      reportType="event"
      withoutCard
      benefitCountLabel="Quantidade de benefícios"
      errorLabel="experiências"
    />
  );
}
